module.exports = __webpack_public_path__ + "media/promo/courses/images/vars-cd74e45e58caec052bb2722d233d26ae.png";